import { Entity } from 'src/app/core/data/schema/entity';

export class Profile extends Entity {

    static className = 'Profile';
    static idField = 'userId';

    static class = 'Profile';

    displayName: string;
    username: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    userId: number;
    phone: string;
    loginMethod: LoginMethod;
    emailConfirmed: boolean;
    stripeSecretKey: string;
    stripeWebhookSecret: string;
    payPalClientId: string;
    payPalSecretKey: string;
    squareAccessToken: string;
    squareLocationId: string;
    squareWebhookSecret: string;
    braintreeMerchantId: string;
    braintreePublicKey: string;
    braintreeSecretKey: string;
    emailSetting: number;
    eventBundlesRemaining: number;
    redirectActiveAuction: boolean;
    
    // for partner based stuffs
    isPartner: boolean;
    partnerFee: number;
    stripeAccountEmail: string;
    stripeAccountId: string;
    stripeSetupComplete = false;

    public constructor(profile?: Partial<Profile>) {
        super('User', 'userId', 'users');
        Object.assign(this, profile);
    }

    get loginMethodString() {
        switch(this.loginMethod) {
            case 1: return 'Facebook'; break;
            case 2: return 'LinkedIn'; break;
            case 3: return 'Google'; break;
            default: return 'email & password'; break;
        }
    }

    public static async loadMine() {
        return await Profile.getObject(Profile, 'users');
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }

}

enum LoginMethod {
    Facebook = 1,
    LinkedIn = 2,
    Google = 3,
    Email = 4,
    CBS = 5
}

    